import * as React from "react";
import { useLoc } from "../../hooks/useLoc";
import { useMonth } from "../../hooks/useMonth";
import { monthSlugsWithOverview } from "../../services/centralStore";
import getLocationPath from "../../services/getLocationPath";
import { CityBase } from "../../templates/fragments/city";
import { CountryBase } from "../../templates/fragments/country";
import { RegionBase } from "../../templates/fragments/region";
import { ResortBase } from "../../templates/fragments/resort";
import { Breadcrumbs as SharedBreadcrumbs } from "../shared/breadcrumbs";

export const Breadcrumbs = ({
    resort = null,
    region = null,
    country = null,
    continent = null,
    city = null
}: {
    resort?: ResortBase;
    region?: RegionBase;
    country?: CountryBase;
    city?: CityBase;
    continent?: string;
}) => {
    const loc = useLoc();
    const { month } = useMonth({});
    // defined for all exc continents, isCountry keep track if original was country
    country = country || region?.country || resort?.region.country;
    // defined for resort and region, we need to ask if resort is missing
    region = region || resort?.region;
    const continentKey = continent || country?.continent;
    const continentName = loc("common.continents." + continentKey);
    const monthIndex = monthSlugsWithOverview.indexOf(month);

    const links: { path: string; text: string }[] = [];
    links.push({ path: "/", text: "Home" });
    links.push({
        path: `/${continentKey}-weather-climate/`,
        text: continentName
    });
    if (!continent) {
        links.push({
            path: getLocationPath({
                location: country,
                isCountryInstance: true,
                monthIndex: monthIndex
            }),
            text: country.name
        });
    }
    if (region && !region.isCountry) {
        links.push({
            path: getLocationPath({
                location: region,
                isCountryInstance: false,
                monthIndex: monthIndex
            }),
            text: region.slugName || region.name
        });
    }
    if (resort) {
        links.push({
            path: getLocationPath({
                location: resort,
                isCountryInstance: false,
                isResortInstance: true,
                monthIndex: monthIndex
            }),
            text: resort.name
        });
    }

    return (
        <>
            <SharedBreadcrumbs links={links} />
        </>
    );
};
